import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import ru from "./locales/ru.json"
import en from "./locales/en.json"
import es from "./locales/es.json"

const STORAGE_KEY = "i18nextLng"

function getInitialLanguage() {
  const stored = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null
  if (stored === "en" || stored === "ru" || stored === "es") return stored
  if (typeof navigator !== "undefined" && navigator.language && navigator.language.startsWith("es")) return "es"
  if (typeof navigator !== "undefined" && navigator.language && navigator.language.startsWith("en")) return "en"
  return "ru"
}

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  fallbackLng: "ru",
  resources: {
    ru: { translation: ru },
    en: { translation: en },
    es: { translation: es },
  },
  interpolation: {
    escapeValue: false,
  },
})

i18n.on("languageChanged", (lng) => {
  if (typeof window !== "undefined") localStorage.setItem(STORAGE_KEY, lng)
})

export default i18n
